import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/tasks/:taskId']['DELETE'];
type Input = THIS_API['params'];

const dismissTask = async ({ taskId }: Input): Promise<void | { associatedInboxId?: string }> => {
  const response = await noodleApiClient.delete(`/tasks/${taskId}`);
  return response.data;
};
export default dismissTask;
